// extracted by mini-css-extract-plugin
module.exports = {"button":"BlockButton_button____LAc","buttonOutline":"BlockButton_buttonOutline__l_ofB"};